module.exports = __webpack_public_path__ + "img/star4yellow.ecb14f9d.png";